// import actions
import moduloAction from './actions/modulo'
import perfilAction from './actions/perfil'
import usuarioAction from './actions/usuario'
import permisoAction from './actions/permiso'

// import getters
import moduloGetter from './getters/modulo'
import perfilGetter from './getters/perfil'
import usuarioGetter from './getters/usuario'

// import mutations
import moduloMutation from './mutations/modulo'
import perfilMutation from './mutations/perfil'
import usuarioMutation from './mutations/usuario'

// import states
import moduloState from './states/modulo'
import perfilState from './states/perfil'
import usuarioState from './states/usuario'

const actions = {
  ...moduloAction,
  ...perfilAction,
  ...permisoAction,
  ...usuarioAction,
}

const getters = {
  ...moduloGetter,
  ...perfilGetter,
  ...usuarioGetter,
}

const mutations = {
  ...moduloMutation,
  ...perfilMutation,
  ...usuarioMutation,
}

const state = {
  ...moduloState,
  ...perfilState,
  ...usuarioState,
}

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
